// extracted by mini-css-extract-plugin
export default {"scroll":"Table_scroll__DVUqE","table":"Table_table__GnYuE"};